export * from './allFaces';
export * from './ComposableTask';
export * from './ComputeFaceDescriptorsTasks';
export * from './detectFaces';
export * from './DetectFacesTasks';
export * from './DetectFaceLandmarksTasks';
export * from './FaceMatcher';
export * from './nets';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/face-api.js/build/es6/globalApi/index.js
// module id = 2281
// module chunks = 0